// lib/events.ts
export type GoogleIntegrationEventDetail =
	| { type: 'configured'; value: boolean }
	| { type: 'connected'; value: boolean };

export function emitGoogleIntegration(detail: GoogleIntegrationEventDetail) {
	window.dispatchEvent(
		new CustomEvent('allcoach:google-integration', { detail }),
	);
}
